import QR from "../components/QR"
import PasswordGenerator from "../components/PasswordGenerator";
import TextCaseGenerator from "../components/TextCaseGenerator"
import QrCodeScanner from "../components/QrCodeScanner";
import Base64EncoderDecoder from "../components/Base64EncoderDecoder";
import LoanCalculator from "../components/LoanCalculator";

const tools = [
  {
    title: "QR Code Generator",
    description: "Create secure and random passwords of varying complexity.",
    isDisabled: false,
    link: "qrgenerator",
    component: QR,
  },
  {
    title: "QR Code Scanner",
    description: "Create secure and random passwords of varying complexity.",
    isDisabled: false,
    link: "qrscanner",
    component: QrCodeScanner,
  },
  {
    title: "Password Generator",
    description: "Create secure and random passwords of varying complexity.",
    isDisabled: false,
    link: "password",
    component: PasswordGenerator,
  },
  {
    title: "Unit Converter",
    description:
      "Convert between various units like length, weight, volume, and more.",
    isDisabled: true,
    link: "",
    component: "",
  },
  {
    title: "Currency Converter",
    description: "Real-time currency exchange rates with conversion options.",
    isDisabled: true,
    link: "",
    component: "",
  },
  {
    title: "Markdown Editor",
    description: "Write, preview, and export markdown documents.",
    isDisabled: true,
    link: "",
    component: "",
  },
  {
    title: "Image Compressor",
    description: "Reduce the size of images without compromising quality.",
    isDisabled: true,
    link: "",
    component: "",
  },
  {
    title: "JSON Formatter & Validator",
    description:
      "Format and validate JSON data for easy readability and error checking.",
    isDisabled: true,
    link: "",
    component: "",
  },
  {
    title: "Base64 Encoder/Decoder",
    description: "Convert text or files to Base64 encoding and vice versa.",
    isDisabled: false,
    link: "base64_encode_decode",
    component: Base64EncoderDecoder,
  },
  {
    title: "Text Diff Checker",
    description: "Compare two text files or strings and highlight differences.",
    isDisabled: true,
    link: "",
    component: "",
  },
  {
    title: "Text Case Converter",
    description:
      "Easily convert text between different cases like UPPERCASE, lowercase, Title Case, etc.",
    isDisabled: false,
    link: "textcasegenerator",
    component: TextCaseGenerator,
  },
  {
    title: "Hex to RGB / RGB to Hex Converter",
    description: "Convert color values between hexadecimal and RGB formats.",
    isDisabled: true,
    link: "",
    component: "",
  },
  {
    title: "HTML CSS Minifier",
    description:
      "Minify HTML, CSS, or JavaScript files for optimized web performance.",
    isDisabled: true,
    link: "",
    component: "",
  },
  {
    title: "BMI Calculator",
    description: "Calculate Body Mass Index based on height and weight.",
    isDisabled: true,
    link: "",
    component: "",
  },
  {
    title: "Timestamp Converter",
    description:
      "Convert Unix timestamps to human-readable dates and vice versa.",
    isDisabled: true,
    link: "",
    component: "",
  },
  {
    title: "Loan Calculator",
    description:
      "Calculate loan repayments, interest rates, and amortization schedules.",
    isDisabled: false,
    link: "loancalculator",
    component: LoanCalculator,
  },
  {
    title: "File Merger",
    description: "Combine multiple PDF or text files into a single file.",
    isDisabled: true,
    link: "",
    component: "",
  },
];

export default tools;
